import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { fetchApiLogsWithFilters } from '../services/api';

// Fetch API logs with filters and pagination
export const getApiLogsWithFilters = createAsyncThunk(
    'apiLogs/getApiLogsWithFilters',
    async (params, { rejectWithValue }) => {
        try {
            const data = await fetchApiLogsWithFilters(params);
            return data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || 'Failed to fetch API logs.');
        }
    }
);

const apiLogSlice = createSlice({
    name: 'apiLogs',
    initialState: {
        logs: [],
        status: 'idle',
        error: null,
        pagination: {
            page: 1,
            page_size: 20,
            count: 0,
            total_count: 0,
            total_pages: 1,
        },
        filters: {},
    },
    reducers: {
        setFilters: (state, action) => {
            state.filters = action.payload;
        },
        resetFilters: (state) => {
            state.filters = {};
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getApiLogsWithFilters.pending, (state) => {
                state.status = 'loading';
                state.error = null;
            })
            .addCase(getApiLogsWithFilters.fulfilled, (state, action) => {
                state.status = 'succeeded';
                if (action.payload.status === 1 || action.payload.data) {
                    state.logs = action.payload.data || [];
                    if (action.payload.pagination) {
                        state.pagination = {
                            page: action.payload.pagination.page || action.payload.page || 1,
                            page_size: action.payload.pagination.page_size || action.payload.page_size || 20,
                            count: action.payload.pagination.count || action.payload.count || 0,
                            total_count: action.payload.pagination.total_count || action.payload.total_count || 0,
                            total_pages: action.payload.pagination.total_pages || action.payload.total_pages || 1,
                        };
                    } else if (action.payload.page) {
                        // Handle direct pagination fields in response
                        state.pagination = {
                            page: action.payload.page || 1,
                            page_size: action.payload.page_size || 20,
                            count: action.payload.count || 0,
                            total_count: action.payload.total_count || 0,
                            total_pages: action.payload.total_pages || 1,
                        };
                    }
                } else {
                    state.logs = [];
                    state.error = 'Failed to fetch API logs';
                }
            })
            .addCase(getApiLogsWithFilters.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload || action.error.message;
            });
    },
});

export const { setFilters, resetFilters } = apiLogSlice.actions;
export default apiLogSlice.reducer;
